(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncs-boutique"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    /* ncs-shop-search:start
       Recherche (spec 4.8) : minuscules, accents et ponctuation ignores, reference avec ou sans tirets
       (FR-33, fr33, fr 33), numero de teinte exact (171), synonymes du metier ; tous les mots doivent trouver
       une correspondance (debut d'un mot du titre, du titre boutique, de la marque, de la categorie ou de la reference). */
    const norm = (s) =>
      String(s || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    const compact = (s) => norm(s).replace(/ /g, '');
    const SYN = [
      [['vernis', 'vsp', 'semi', 'semi permanent', 'semipermanent', 'gel polish', 'polish'], 'cat', ['vsp']],
      [['top', 'tops', 'topcoat', 'top coat', 'finition'], 'cat', ['top']],
      [['fraise', 'fraises', 'bit', 'bits', 'embout', 'embouts', 'meche', 'meches'], 'cat', ['embout']],
      [['builder', 'construction', 'renfort', 'wonder'], 'cat', ['construction']],
      [['cat eye', 'cat eyes', 'cateye', 'oeil de chat', 'magnetique'], 'cat', ['cateye']],
      [['liner', 'nail art', 'nailart', 'deco'], 'cat', ['nailart']],
      [['prep', 'preparation', 'primer', 'degraissant', 'cleaner'], 'cat', ['prep']],
      [['pochette', 'pochettes', 'sterile', 'sterilisation'], 'gamme', ['pochette-microstop']],
      [['pop it', 'popit', 'dual form', 'dual forms', 'dual forme'], 'gamme', ['dual-forms-notd']],
      [['pied', 'pieds', 'pedicure'], 'cat', ['pieds']],
      [['base', 'bases'], 'cat', ['base']],
      [['nude', 'nudes', 'clair', 'clairs', 'blanc'], 'fam', ['clairs']],
      [['rose', 'roses', 'corail'], 'fam', ['roses']],
      [['rouge', 'rouges', 'bordeaux'], 'fam', ['rouges']],
      [['bleu', 'bleus', 'vert', 'verts'], 'fam', ['bleus']],
      [['violet', 'violets', 'mauve'], 'fam', ['violets']],
      [['noir', 'noirs', 'brun', 'bruns', 'marron', 'chocolat'], 'fam', ['fonces']],
    ];
    const SYN_MAP = {};
    SYN.forEach((s) => s[0].forEach((t) => (SYN_MAP[t] = s)));
    const PHRASES = Object.keys(SYN_MAP)
      .filter((t) => t.includes(' '))
      .sort((a, b) => b.length - a.length);
    const parseQuery = (q) => {
      const qn = norm(q);
      if (!qn) return null;
      let rest = ` ${qn} `;
      const units = [];
      PHRASES.forEach((ph) => {
        if (rest.includes(` ${ph} `)) {
          units.push({ syn: SYN_MAP[ph] });
          rest = rest.replace(` ${ph} `, ' ');
        }
      });
      rest
        .trim()
        .split(' ')
        .filter(Boolean)
        .forEach((w) => units.push({ w, syn: SYN_MAP[w] || null }));
      return { units, qc: qn.replace(/ /g, '') };
    };
    const matchQuery = (it, pq) => {
      if (it.skuC && pq.qc.length >= 2 && (it.skuC === pq.qc || (pq.qc.length >= 3 && it.skuC.startsWith(pq.qc)))) return true;
      return (
        pq.units.length > 0 &&
        pq.units.every(
          (u) =>
            (u.syn && u.syn[2].includes(it[u.syn[1]])) ||
            (u.w && (it.n === u.w || it.tokens.some((t) => t.startsWith(u.w))))
        )
      );
    };
    /* ncs-shop-search:end */

    const plural = (n, one, many) => `${n} ${n > 1 ? many : one}`;
    let fmt = null;
    try {
      fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      fmt = null;
    }
    const money = (c) => {
      if (window.NCS && typeof window.NCS.money === 'function') return window.NCS.money(c);
      return fmt ? fmt.format(c / 100) : `${(c / 100).toFixed(2).replace('.', ',')} €`;
    };
    const LIST_KEY = 'ncs-list-v1';
    const storageOk = (() => {
      try {
        window.localStorage.setItem('ncs-shop-test', '1');
        window.localStorage.removeItem('ncs-shop-test');
        return true;
      } catch (e) {
        return false;
      }
    })();
    const readList = () => {
      try {
        const raw = JSON.parse(window.localStorage.getItem(LIST_KEY) || '[]');
        if (!Array.isArray(raw)) return [];
        return raw
          .map((x) =>
            x && typeof x === 'object'
              ? { id: Number(x.id), qty: Math.min(99, Math.max(1, Math.floor(Number(x.qty) || 1))) }
              : { id: Number(x), qty: 1 }
          )
          .filter((x) => x.id > 0);
      } catch (e) {
        return [];
      }
    };
    const writeList = (list) => {
      try {
        window.localStorage.setItem(LIST_KEY, JSON.stringify(list));
        return true;
      } catch (e) {
        return false;
      }
    };
    const SUGGEST = ['vernis', 'rubber', 'top coat', 'fraise', 'builder', 'cat eye', 'gants', 'cleaner', 'nude', 'rouge', 'liner', 'pochette', 'primer', 'embout', 'FR-33', 'SILL-BG'];
    const bigrams = (s) => {
      const c = compact(s);
      const out = [];
      for (let i = 0; i < c.length - 1; i += 1) out.push(c.slice(i, i + 2));
      return out;
    };
    const luminance = (hex) => {
      const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
      if (!m) return 0;
      const n = parseInt(m[1], 16);
      return (0.2126 * ((n >> 16) & 255) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255)) / 255;
    };

    function initShop(root) {
      if (root.dataset.ncsReady) return;
      root.dataset.ncsReady = '1';
      const $ = (s) => root.querySelector(s);
      const $$ = (s) => Array.from(root.querySelectorAll(s));
      const ac = new AbortController();
      const signal = ac.signal;
      const html = document.documentElement;
      const vatDiv = 100 + (Number(root.dataset.vat) || 0);
      const showHT = root.dataset.ht === '1';
      const threshold = Number(root.dataset.threshold) || 0;
      const openN = Number(root.dataset.open) || 0;
      let cartTotal = Number(root.dataset.cart) || 0;
      const ht = (c) => money(Math.round((c * 100) / vatDiv));
      const el = {
        count: $('[data-count]'),
        q: $('[data-q]'),
        qClear: $('[data-q-clear]'),
        qCount: $('[data-q-count]'),
        form: $('[data-search-form]'),
        tb: $('[data-tb]'),
        results: $('[data-results]'),
        qo: $('[data-qo]'),
        table: $('[data-table]'),
        thead: $('[data-table] thead'),
        all: $('[data-all]'),
        fill: $('[data-fill]'),
        fillLabel: $('[data-fill-label]'),
        grid: $('[data-grid]'),
        gridList: $('[data-grid-list]'),
        tpl: $('[data-card-tpl]'),
        empty: $('[data-empty]'),
        emptyTitle: $('[data-empty-title]'),
        suggestWrap: $('[data-suggest-wrap]'),
        suggest: $('[data-suggest]'),
        resetAll: $('[data-reset-all]'),
        qReset: $('[data-q-reset]'),
        reset: $('[data-reset]'),
        listChip: $('[data-chip-list]'),
        recap: $('[data-recap]'),
        recapCount: $('[data-recap-count]'),
        recapSum: $('[data-recap-sum]'),
        recapHT: $('[data-recap-ht]'),
        recapShip: $('[data-recap-ship]'),
        recapShipMsg: $('[data-recap-shipmsg]'),
        recapAdd: $('[data-recap-add]'),
        recapLabel: $('[data-recap-label]'),
        recapMsg: $('[data-recap-msg]'),
        live: $('[data-live]'),
        views: $$('[data-view]'),
        needChips: $$('[data-chip-need]'),
        brandChips: $$('[data-chip-brand]'),
      };
      if (!el.table || !el.q || !el.recap) return;
      const say = (t) => {
        if (!el.live) return;
        el.live.textContent = '';
        window.requestAnimationFrame(() => (el.live.textContent = t));
      };

      /* Lignes et groupes, lus une fois dans le DOM rendu par le serveur */
      const groups = $$('[data-group]').map((tbody) => ({
        el: tbody,
        key: tbody.dataset.group,
        btn: tbody.querySelector('[data-toggle]'),
        countEl: tbody.querySelector('[data-gcount]'),
        selEl: tbody.querySelector('[data-gsel]'),
        items: [],
        n: 0,
        open: tbody.classList.contains('is-open'),
      }));
      const groupByEl = new Map(groups.map((g) => [g.el, g]));
      const items = [];
      const byRow = new Map();
      const byId = new Map();
      $$('[data-row]').forEach((row) => {
        const d = row.dataset;
        const it = {
          row,
          id: Number(d.id),
          price: Number(d.price) || 0,
          need: d.need || '',
          cat: d.cat || '',
          brand: d.brand || '',
          gamme: d.gamme || '',
          fam: d.fam || '',
          n: d.n || '',
          sku: (d.sku || '').replace(/[^\x20-\x7e]/g, '').trim(),
          skuC: compact(d.sku),
          tokens: norm(`${d.q || ''} ${d.sku || ''}`).split(' ').filter(Boolean),
          out: 'out' in d,
          input: row.querySelector('[data-ncs-qty]'),
          totalEl: row.querySelector('[data-total]'),
          fav: row.querySelector('[data-fav]'),
          group: groupByEl.get(row.parentElement) || null,
          match: true,
          card: null,
        };
        if (it.group) it.group.items.push(it);
        items.push(it);
        byRow.set(row, it);
        byId.set(it.id, it);
      });

      /* Etat initial lu dans l'URL */
      const params = new URLSearchParams(window.location.search);
      const needKeys = new Set(el.needChips.map((b) => b.dataset.chipNeed));
      const brandByC = new Map(el.brandChips.map((b) => [compact(b.dataset.chipBrand), b.dataset.chipBrand]));
      const state = {
        need: needKeys.has(params.get('besoin')) ? params.get('besoin') : '',
        brands: [
          ...new Set(
            (params.get('marque') || '')
              .split(',')
              .map((b) => brandByC.get(compact(b)))
              .filter(Boolean)
          ),
        ],
        q: (params.get('q') || '').trim().slice(0, 80),
        view: params.get('vue') === 'grille' ? 'grille' : 'commande',
        list: storageOk && params.get('liste') === '1',
      };
      const sel = new Map();
      let overrides = {};
      let list = storageOk ? readList() : [];
      let gridBuilt = false;
      let recapShown = false;
      let busy = false;
      let stepClick = null;
      if (storageOk) root.setAttribute('data-list', '');

      const filtersActive = () => Boolean(state.q || state.need || state.brands.length || state.list);
      const listIds = () => new Set(list.map((x) => x.id));
      const groupSel = (g) => g.items.reduce((s, it) => s + (sel.get(it.id) || 0), 0);
      const visibleInputs = () => items.filter((it) => it.match && !it.out && it.group && it.group.open).map((it) => it.input);

      function setOpen(g, open) {
        g.open = open;
        g.el.classList.toggle('is-open', open);
        g.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      function syncAllBtn() {
        const vis = groups.filter((g) => g.n > 0);
        el.all.hidden = vis.length < 2;
        el.all.textContent = vis.length && vis.every((g) => g.open) ? 'Tout replier' : 'Tout déplier';
      }
      function syncGroupBadge(g) {
        if (!g) return;
        const n = groupSel(g);
        g.selEl.hidden = !n;
        g.selEl.textContent = n ? plural(n, 'article choisi', 'articles choisis') : '';
      }
      function setChip(b, pressed, n) {
        b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        const c = b.querySelector('[data-n]');
        if (c) c.textContent = String(n);
        b.disabled = !pressed && n === 0;
      }
      function syncStepper(it) {
        const st = it.input && it.input.closest('[data-ncs-stepper]');
        if (!st) return;
        const v = Number(it.input.value) || 0;
        const minus = st.querySelector('[data-ncs-step="-1"]');
        const plus = st.querySelector('[data-ncs-step="1"]');
        if (minus) minus.disabled = it.out || v <= 0;
        if (plus) plus.disabled = it.out || v >= 99;
      }
      function syncFavs() {
        const ids = listIds();
        let present = 0;
        let fillable = 0;
        items.forEach((it) => {
          const on = ids.has(it.id);
          if (it.fav) it.fav.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on) present += 1;
          if (on && !it.out) fillable += 1;
        });
        if (el.listChip) {
          el.listChip.hidden = !present && !state.list;
          setChip(el.listChip, state.list, present);
          el.listChip.disabled = false;
        }
        el.fill.hidden = !fillable;
        el.fillLabel.textContent = `Remplir avec ma liste (${fillable})`;
      }

      /* Rendu : filtres combines (besoin ET marques ET liste ET recherche), compteurs, groupes, grille */
      function render() {
        const pq = parseQuery(state.q);
        const ids = state.list ? listIds() : null;
        const needCount = {};
        const brandCount = {};
        let allCount = 0;
        let total = 0;
        items.forEach((it) => {
          const qOk = !pq || matchQuery(it, pq);
          const needOk = !state.need || it.need === state.need;
          const brandOk = !state.brands.length || state.brands.includes(it.brand);
          const listOk = !ids || ids.has(it.id);
          if (qOk && brandOk && listOk) {
            needCount[it.need] = (needCount[it.need] || 0) + 1;
            allCount += 1;
          }
          if (qOk && needOk && listOk && it.brand) brandCount[it.brand] = (brandCount[it.brand] || 0) + 1;
          const m = qOk && needOk && brandOk && listOk;
          if (m !== it.match) {
            it.match = m;
            it.row.hidden = !m;
            if (it.card) it.card.hidden = !m;
          }
          if (m) total += 1;
        });
        const active = filtersActive();
        let gi = 0;
        groups.forEach((g) => {
          g.n = g.items.reduce((s, it) => s + (it.match ? 1 : 0), 0);
          g.el.hidden = g.n === 0;
          g.countEl.textContent = `(${g.n})`;
          if (!g.n) return;
          const open = g.key in overrides ? overrides[g.key] : active || gi < openN || groupSel(g) > 0;
          setOpen(g, open);
          gi += 1;
        });
        syncAllBtn();
        el.needChips.forEach((b) => {
          const k = b.dataset.chipNeed;
          setChip(b, k === state.need, k ? needCount[k] || 0 : allCount);
        });
        el.brandChips.forEach((b) => {
          const k = b.dataset.chipBrand;
          setChip(b, state.brands.includes(k), brandCount[k] || 0);
        });
        syncFavs();
        if (el.reset) el.reset.hidden = !(state.need || state.brands.length || state.list);
        el.count.textContent =
          (total ? plural(total, 'produit', 'produits') : 'Aucun produit') +
          (state.q ? ` pour \u00ab\u00a0${state.q}\u00a0\u00bb` : '');
        if (el.qCount) {
          el.qCount.hidden = !state.q;
          el.qCount.textContent = state.q ? (total ? plural(total, 'résultat', 'résultats') : 'Aucun résultat') : '';
          el.form.classList.toggle('has-count', Boolean(state.q));
        }
        el.qo.hidden = state.view !== 'commande' || !total;
        el.grid.hidden = state.view !== 'grille' || !total;
        if (state.view === 'grille' && !gridBuilt) buildGrid();
        renderEmpty(total);
        syncWhatsApp();
        syncRecap();
        root.removeAttribute('data-pending');
      }

      function renderEmpty(total) {
        el.empty.hidden = total > 0;
        if (total > 0) return;
        const hasFilters = Boolean(state.need || state.brands.length || state.list);
        if (!items.length) el.emptyTitle.textContent = 'Aucun produit dans cette collection.';
        else if (state.q) el.emptyTitle.textContent = `Aucun produit pour \u00ab\u00a0${state.q}\u00a0\u00bb.`;
        else if (state.list && !listIds().size) el.emptyTitle.textContent = 'Votre liste de réassort est vide.';
        else el.emptyTitle.textContent = 'Aucun produit ne correspond à ces filtres.';
        const sugg = state.q ? suggestionsFor(state.q) : [];
        el.suggestWrap.hidden = !sugg.length;
        el.suggest.textContent = '';
        sugg.forEach((t) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ncs-chip ncs-chip--outline';
          b.dataset.try = t;
          b.textContent = t;
          el.suggest.append(b);
        });
        el.resetAll.hidden = !hasFilters;
        el.qReset.hidden = !state.q;
      }
      function suggestionsFor(q) {
        const qb = bigrams(q);
        return SUGGEST.map((t, i) => ({ t, s: bigrams(t).filter((b) => qb.includes(b)).length * 10 - i }))
          .sort((a, b) => b.s - a.s)
          .map((x) => x.t)
          .filter((t) => {
            if (compact(t) === compact(q)) return false;
            const pq = parseQuery(t);
            return items.some((it) => matchQuery(it, pq));
          })
          .slice(0, 3);
      }
      function syncWhatsApp() {
        const text = `Bonjour, je cherche une référence sur votre boutique${state.q ? ` : ${state.q}` : ''}.`;
        $$('[data-wa-search]').forEach((a) => {
          const num = (a.dataset.ncsWa || '').replace(/\D/g, '');
          a.dataset.ncsWaText = text;
          if (num) a.href = `https://wa.me/${num}?text=${encodeURIComponent(text)}`;
        });
      }
      function writeURL() {
        try {
          const url = new URL(window.location.href);
          const p = url.searchParams;
          const set = (k, v) => (v ? p.set(k, v) : p.delete(k));
          set('besoin', state.need);
          set('marque', state.brands.join(','));
          set('q', state.q);
          set('vue', state.view === 'grille' ? 'grille' : '');
          set('liste', state.list ? '1' : '');
          const qs = p.toString();
          const next = url.pathname + (qs ? `?${qs}` : '') + url.hash;
          if (next !== window.location.pathname + window.location.search + window.location.hash) {
            window.history.replaceState(window.history.state, '', next);
          }
        } catch (e) {
          /* bac a sable : l'etat reste en memoire */
        }
      }
      function keepResultsInView() {
        const top = el.results.getBoundingClientRect().top;
        const limit = el.tb.getBoundingClientRect().bottom;
        if (top < limit - 1) el.results.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
      function update(opts = {}) {
        overrides = {};
        render();
        writeURL();
        if (opts.scroll !== false) keepResultsInView();
      }

      /* Grille (B3a) : cartes construites une fois depuis les lignes, filtrees avec elles */
      function buildGrid() {
        gridBuilt = true;
        const tpl = el.tpl && el.tpl.content.firstElementChild;
        if (!tpl) return;
        const frag = document.createDocumentFragment();
        items.forEach((it) => {
          const c = tpl.cloneNode(true);
          const link = it.row.querySelector('.ncs-qo__title');
          const sub = it.row.querySelector('.ncs-qo__brand');
          const title = link ? link.textContent.trim() : '';
          const a = c.querySelector('[data-c-link]');
          a.href = link ? link.getAttribute('href') : '#';
          a.textContent = title;
          const brand = c.querySelector('[data-c-brand]');
          if (sub) brand.textContent = sub.textContent.trim();
          else brand.remove();
          const sku = c.querySelector('[data-c-sku]');
          if (it.sku) sku.textContent = `Réf. ${it.sku}`;
          else sku.remove();
          c.querySelector('[data-c-price]').textContent = money(it.price);
          const htEl = c.querySelector('[data-c-ht]');
          if (showHT) htEl.textContent = `soit ${ht(it.price)} HT`;
          else htEl.remove();
          const media = c.querySelector('.ncs-card__media');
          const img = media.querySelector('img');
          const src = it.row.dataset.img;
          if (src) {
            img.srcset = `${src.replace(/([?&])width=\d+/, '$1width=200')} 200w, ${src} 400w`;
            img.src = src;
          } else {
            img.remove();
          }
          if (it.cat === 'vsp' || it.cat === 'gel' || it.cat === 'cateye') media.classList.add('ncs-card__media--cover');
          const hex = it.row.dataset.hex;
          if (hex) {
            const sw = media.querySelector('.ncs-grid__swatch');
            sw.hidden = false;
            sw.style.setProperty('--ncs-swatch-color', hex);
            if (luminance(hex) > 0.8) sw.classList.add('is-light');
          }
          const add = c.querySelector('[data-c-add]');
          if (it.out) {
            c.classList.add('is-out');
            c.querySelector('[data-c-out]').hidden = false;
            add.remove();
          } else {
            add.dataset.ncsAddVariant = String(it.id);
            add.setAttribute('aria-label', `Ajouter au panier : ${title}`);
          }
          c.hidden = !it.match;
          it.card = c;
          frag.append(c);
        });
        el.gridList.append(frag);
      }

      /* Bon de commande (B3b) : selection en memoire, cle = variante, bornes 0 a 99 */
      function setQty(it, value, writeInput) {
        const q = Math.max(0, Math.min(99, Math.floor(Number(value)) || 0));
        if (q > 0) sel.set(it.id, q);
        else sel.delete(it.id);
        if (writeInput) {
          it.input.value = String(q);
          syncStepper(it);
        }
        it.row.classList.toggle('is-selected', q > 0);
        if (it.totalEl) it.totalEl.textContent = q > 0 ? money(q * it.price) : '';
        syncGroupBadge(it.group);
      }
      function onQty(e) {
        const input = e.target instanceof Element ? e.target.closest('[data-ncs-qty]') : null;
        if (!input) return;
        const it = byRow.get(input.closest('[data-row]'));
        if (!it || it.out) return;
        if (e.type === 'input' && input.value === '') return;
        setQty(it, input.value, false);
        syncRecap();
        /* Retour a 0 avec le bouton moins (desactive, replie en mobile) : le focus passe au bouton plus */
        if (e.type === 'change' && !sel.has(it.id) && stepClick && stepClick.dataset.ncsStep === '-1') {
          const st = input.closest('[data-ncs-stepper]');
          const plus = st && st.contains(stepClick) ? st.querySelector('[data-ncs-step="1"]') : null;
          if (plus && !plus.disabled) plus.focus({ preventScroll: true });
        }
      }
      function selection() {
        const lines = [];
        let n = 0;
        let total = 0;
        sel.forEach((q, id) => {
          const it = byId.get(id);
          if (!it || it.out || q < 1) return;
          lines.push({ id, quantity: q });
          n += q;
          total += q * it.price;
        });
        return { lines, n, total };
      }
      function clearSelection(byUser) {
        if (!sel.size) return;
        const ids = Array.from(sel.keys());
        sel.clear();
        ids.forEach((id) => {
          const it = byId.get(id);
          if (it) setQty(it, 0, true);
        });
        if (byUser) {
          say('Sélection vidée');
          const first = visibleInputs()[0];
          if (first) first.focus({ preventScroll: true });
        }
        syncRecap();
      }

      /* Recapitulatif (B4) : visible des qu'une quantite est choisie, en vue commande rapide */
      function syncRecap() {
        const s = selection();
        const show = state.view === 'commande' && s.n > 0;
        el.recapCount.textContent = plural(s.n, 'article', 'articles');
        el.recapSum.textContent = money(s.total);
        if (el.recapHT) el.recapHT.textContent = showHT ? `soit ${ht(s.total)} HT` : '';
        if (!busy) el.recapLabel.textContent = s.n ? `Ajouter au panier (${s.n}) · ${money(s.total)}` : 'Ajouter au panier';
        if (el.recapShip && threshold > 0) {
          const reach = cartTotal + s.total;
          const left = threshold - reach;
          el.recapShip.classList.toggle('is-done', left <= 0);
          el.recapShip.style.setProperty('--ncs-ship-progress', Math.min(1, reach / threshold).toFixed(3));
          el.recapShipMsg.textContent =
            left > 0 ? `Plus que ${money(left)} pour la livraison offerte` : 'Livraison offerte en France métropolitaine';
        }
        if (show !== recapShown) {
          recapShown = show;
          if (!show && el.recap.contains(document.activeElement)) {
            const back = el.views.find((b) => b.dataset.view === 'commande');
            if (back) back.focus({ preventScroll: true });
          }
          el.recap.classList.toggle('is-visible', show);
          el.recap.toggleAttribute('inert', !show);
          html.classList.toggle('ncs-shop-recap', show);
        }
      }
      async function addSelection() {
        if (busy) return;
        const s = selection();
        if (!s.lines.length) return;
        const N = window.NCS;
        if (!N || typeof N.addLines !== 'function') {
          el.recapMsg.textContent = 'L’ajout est indisponible pour le moment. Rechargez la page.';
          return;
        }
        busy = true;
        el.recapMsg.textContent = '';
        el.recapAdd.classList.add('is-busy');
        el.recapAdd.setAttribute('aria-disabled', 'true');
        el.recapLabel.textContent = 'Ajout...';
        let res;
        try {
          res = await N.addLines(s.lines, el.recapAdd);
        } catch (e) {
          res = { ok: false, message: 'Connexion interrompue, réessayez.' };
        }
        busy = false;
        el.recapAdd.classList.remove('is-busy');
        el.recapAdd.removeAttribute('aria-disabled');
        if (res && res.ok) {
          clearSelection(false);
        } else {
          el.recapMsg.textContent = (res && res.message) || 'Ajout impossible, réessayez.';
          syncRecap();
        }
      }

      /* Liste de reassort (localStorage 'ncs-list-v1', meme format que la maquette : [{ id, qty }]) */
      function toggleFav(it) {
        list = readList();
        const i = list.findIndex((x) => x.id === it.id);
        if (i >= 0) list.splice(i, 1);
        else list.push({ id: it.id, qty: Math.max(1, sel.get(it.id) || 1) });
        if (!writeList(list)) list = readList();
        syncFavs();
      }
      function fillFromList() {
        list = readList();
        let n = 0;
        list.forEach((x) => {
          const it = byId.get(x.id);
          if (!it || it.out) return;
          setQty(it, x.qty, true);
          n += x.qty;
        });
        state.q = '';
        el.q.value = '';
        el.qClear.hidden = true;
        state.need = '';
        state.brands = [];
        state.list = true;
        update({ scroll: false });
        say(n ? `${plural(n, 'article', 'articles')} de votre liste dans la sélection` : 'Aucun produit disponible dans votre liste');
        const first = items.find((it) => it.match && sel.has(it.id));
        if (first) first.input.focus();
      }

      function setView(v, focusBtn) {
        const next = v === 'grille' ? 'grille' : 'commande';
        el.views.forEach((b) => {
          const on = b.dataset.view === next;
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          if (on && focusBtn) b.focus();
        });
        if (next === state.view) return;
        state.view = next;
        render();
        writeURL();
      }
      function setQuery(v) {
        state.q = String(v || '').trim().slice(0, 80);
        el.q.value = state.q;
        el.qClear.hidden = !state.q;
      }

      /* Evenements : un ecouteur par type, delegation sur la section */
      root.addEventListener('click', (e) => {
        const t = e.target instanceof Element ? e.target : null;
        if (!t) return;
        /* Bouton du stepper : ncs.js (ecouteur sur document) met a jour la quantite juste apres */
        stepClick = t.closest('[data-ncs-step]');
        if (stepClick) {
          window.setTimeout(() => {
            stepClick = null;
          }, 0);
          return;
        }
        let b = t.closest('[data-chip-need]');
        if (b) {
          const k = b.dataset.chipNeed;
          state.need = k && state.need !== k ? k : '';
          update();
          return;
        }
        if ((b = t.closest('[data-chip-brand]'))) {
          const k = b.dataset.chipBrand;
          state.brands = state.brands.includes(k) ? state.brands.filter((x) => x !== k) : state.brands.concat(k);
          update();
          return;
        }
        if (t.closest('[data-chip-list]')) {
          state.list = !state.list;
          update();
          return;
        }
        if (t.closest('[data-reset], [data-reset-all]')) {
          state.need = '';
          state.brands = [];
          state.list = false;
          update();
          return;
        }
        if (t.closest('[data-q-reset]')) {
          setQuery('');
          update();
          el.q.focus();
          return;
        }
        if ((b = t.closest('[data-try]'))) {
          setQuery(b.dataset.try);
          update();
          return;
        }
        if ((b = t.closest('[data-toggle]'))) {
          const g = groupByEl.get(b.closest('[data-group]'));
          if (!g) return;
          overrides[g.key] = !g.open;
          setOpen(g, !g.open);
          syncAllBtn();
          return;
        }
        if (t.closest('[data-all]')) {
          const vis = groups.filter((g) => g.n > 0);
          const open = !vis.every((g) => g.open);
          vis.forEach((g) => {
            overrides[g.key] = open;
            setOpen(g, open);
          });
          syncAllBtn();
          return;
        }
        if ((b = t.closest('[data-fav]'))) {
          const it = byRow.get(b.closest('[data-row]'));
          if (it) toggleFav(it);
          return;
        }
        if (t.closest('[data-fill]')) {
          fillFromList();
          return;
        }
        if ((b = t.closest('[data-view]'))) {
          setView(b.dataset.view);
          return;
        }
        if (t.closest('[data-recap-add]')) {
          addSelection();
          return;
        }
        if (t.closest('[data-recap-clear]')) clearSelection(true);
      });
      el.views.forEach((b, i) =>
        b.addEventListener('keydown', (e) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
          e.preventDefault();
          const step = e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1;
          setView(el.views[(i + step + el.views.length) % el.views.length].dataset.view, true);
        })
      );

      /* Recherche : filtre au fil de la frappe (120 ms), Entree = premier champ quantite visible */
      let qTimer = 0;
      el.q.addEventListener('input', () => {
        el.qClear.hidden = !el.q.value;
        window.clearTimeout(qTimer);
        qTimer = window.setTimeout(() => {
          const v = el.q.value.trim();
          if (v === state.q) return;
          state.q = v;
          update();
        }, 120);
      });
      el.form.addEventListener('submit', (e) => {
        e.preventDefault();
        window.clearTimeout(qTimer);
        const v = el.q.value.trim();
        if (v !== state.q) {
          state.q = v;
          update();
        }
        if (state.view === 'commande') {
          const first = visibleInputs()[0];
          if (first) first.focus();
        } else if (window.matchMedia('(pointer: coarse)').matches) {
          el.q.blur();
        }
      });
      el.qClear.addEventListener('click', () => {
        window.clearTimeout(qTimer);
        setQuery('');
        update();
        el.q.focus();
      });
      el.q.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !el.q.value) return;
        e.preventDefault();
        window.clearTimeout(qTimer);
        setQuery('');
        update();
      });
      const wide = window.matchMedia('(min-width: 990px)');
      const syncPlaceholder = () => {
        el.q.placeholder = wide.matches ? 'Nom, teinte ou référence (ex. FR-33, Wine, vernis)' : 'Nom, teinte ou référence';
      };
      syncPlaceholder();
      wide.addEventListener('change', syncPlaceholder, { signal });
      /* Mobile : le bouton plus est le geste principal, il entre dans l'ordre de tabulation */
      const narrow = window.matchMedia('(max-width: 749px)');
      const syncPlusTab = () => {
        $$('[data-row] [data-ncs-step="1"]').forEach((b) => {
          b.tabIndex = narrow.matches ? 0 : -1;
        });
      };
      syncPlusTab();
      narrow.addEventListener('change', syncPlusTab, { signal });

      /* Quantites : saisie, fleches, Entree = ligne suivante */
      el.table.addEventListener('input', onQty);
      el.table.addEventListener('change', onQty);
      el.table.addEventListener('focusin', (e) => {
        const input = e.target instanceof HTMLInputElement && e.target.matches('[data-ncs-qty]') ? e.target : null;
        if (input) {
          try {
            input.select();
          } catch (err) {
            /* selection non geree */
          }
        }
      });
      el.table.addEventListener('focusout', (e) => {
        const input = e.target instanceof HTMLInputElement && e.target.matches('[data-ncs-qty]') ? e.target : null;
        if (!input || input.value !== '') return;
        const it = byRow.get(input.closest('[data-row]'));
        if (!it) return;
        input.value = String(sel.get(it.id) || 0);
        syncStepper(it);
      });
      el.table.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;
        const input = e.target instanceof HTMLInputElement && e.target.matches('[data-ncs-qty]') ? e.target : null;
        if (!input) return;
        e.preventDefault();
        input.dispatchEvent(new Event('change', { bubbles: true }));
        const inputs = visibleInputs();
        const next = inputs[inputs.indexOf(input) + 1];
        if (next) next.focus();
        else if (recapShown) el.recapAdd.focus();
      });

      /* Panier : total relu apres chaque ajout (evenement standard d'Horizon), pour l'ecart au seuil */
      document.addEventListener(
        'shopify:cart:lines-update',
        (e) => {
          const p = e && e.promise;
          if (!p || typeof p.then !== 'function') return;
          p.then((r) => {
            const amount = r && r.cart && r.cart.cost && r.cart.cost.totalAmount ? parseFloat(r.cart.cost.totalAmount.amount) : NaN;
            if (Number.isFinite(amount)) {
              cartTotal = Math.round(amount * 100);
              syncRecap();
            }
          }).catch(() => {});
        },
        { signal }
      );

      /* Hauteurs collantes : barre d'outils, en-tete du tableau, recapitulatif (ResizeObserver, aucun scroll) */
      html.classList.add('ncs-shop-page');
      const measure = () => {
        const top = parseFloat(window.getComputedStyle(el.tb).top) || 0;
        const tbH = el.tb.offsetHeight;
        const theadH = el.thead && el.thead.offsetHeight > 2 ? el.thead.offsetHeight : 0;
        root.style.setProperty('--ncs-tb-h', `${tbH}px`);
        html.style.setProperty('--ncs-shop-stick', `${Math.round(top + tbH)}px`);
        html.style.setProperty('--ncs-shop-spt', `${Math.round(top + tbH + theadH + 8)}px`);
        html.style.setProperty('--ncs-recap-h', `${el.recap.offsetHeight}px`);
        watchStuck(top);
      };
      const sentinel = $('[data-tb-sentinel]');
      let io = null;
      let ioKey = '';
      const watchStuck = (top) => {
        if (!sentinel || !('IntersectionObserver' in window)) return;
        const rootEl = window.matchMedia('(min-width: 990px)').matches ? document.querySelector('.page-wrapper') : null;
        const key = `${Math.round(top)}|${rootEl ? 'w' : 'v'}`;
        if (key === ioKey) return;
        ioKey = key;
        if (io) io.disconnect();
        io = new IntersectionObserver(
          ([entry]) => el.tb.classList.toggle('is-stuck', !entry.isIntersecting && entry.boundingClientRect.top < top + 1),
          { root: rootEl, rootMargin: `-${Math.round(top) + 1}px 0px 0px 0px` }
        );
        io.observe(sentinel);
      };
      let ro = null;
      if ('ResizeObserver' in window) {
        ro = new ResizeObserver(measure);
        [el.tb, el.recap, el.thead, document.getElementById('header-component')].forEach((x) => x && ro.observe(x));
      } else {
        measure();
      }
      document.addEventListener(
        'shopify:section:unload',
        (e) => {
          if (!(e.target instanceof Element) || !e.target.contains(root)) return;
          ac.abort();
          if (ro) ro.disconnect();
          if (io) io.disconnect();
          html.classList.remove('ncs-shop-page', 'ncs-shop-recap');
        },
        { signal }
      );

      /* Demarrage */
      el.q.value = state.q;
      el.qClear.hidden = !state.q;
      el.views.forEach((b) => {
        const on = b.dataset.view === state.view;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      render();
      writeURL();
    }

    const boot = () => document.querySelectorAll('[data-ncs-shop]').forEach((root) => initShop(root));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncs-collection-head"] && !Shopify.designMode) return;
  try {
    
  /* Mobile : la pastille de la page courante est amenee dans le champ, une seule fois au chargement
     (aucun ecouteur de defilement). */
  (() => {
    const reveal = (root) => {
      root.querySelectorAll('.ncs-colhead__nav').forEach((nav) => {
        const cur = nav.querySelector('.ncs-colhead__pill.is-current');
        if (!cur || nav.scrollWidth <= nav.clientWidth) return;
        const shift = cur.getBoundingClientRect().left - nav.getBoundingClientRect().left - 16;
        if (shift > 0) nav.scrollLeft += shift;
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => reveal(document), { once: true });
    } else {
      reveal(document);
    }
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) reveal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncs-essentials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ncs-essentials')) return;

    const locale = document.documentElement.lang || 'fr';
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const money = (cents, short) => {
      const value = Math.round(cents) / 100;
      const digits = short && Math.round(cents) % 100 === 0 ? 0 : 2;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(value);
      } catch (e) {
        return `${value.toFixed(digits).replace('.', ',')} €`;
      }
    };
    const ncsReady = () =>
      new Promise((resolve) => {
        if (window.NCS && window.NCS.addLines) {
          resolve(window.NCS);
          return;
        }
        document.addEventListener('ncs:ready', () => resolve(window.NCS), { once: true });
        setTimeout(() => resolve(window.NCS || null), 4000);
      });

    /* Ajout groupe : window.NCS.addLines (tiroir Horizon), sinon ajout direct puis page panier */
    const addLines = async (lines, source, root) => {
      const NCS = await ncsReady();
      if (NCS && NCS.addLines) return NCS.addLines(lines, source);
      try {
        const res = await fetch(root.dataset.cartAddUrl || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: lines }),
        });
        const json = await res.json();
        if (json.status) return { ok: false, message: json.description || json.message };
        window.location.assign(root.dataset.cartUrl || '/cart');
        return { ok: true };
      } catch (e) {
        return { ok: false, message: 'Connexion interrompue, réessayez.' };
      }
    };

    class NcsEssentials extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.vatDiv = 1 + Number(this.dataset.vat || 20) / 100;
        this.threshold = Number(this.dataset.threshold || 0);
        this.defaultQty = Number(this.dataset.defaultQty || 0);
        this.addEventListener('input', (event) => this.onQty(event));
        this.addEventListener('change', (event) => this.onQty(event));
        this.addEventListener('click', (event) => {
          const target = event.target instanceof Element ? event.target : null;
          if (!target) return;
          const add = target.closest('[data-ess-add]');
          if (add) {
            this.add(add);
            return;
          }
          if (target.closest('[data-ess-reset]')) this.reset();
        });
        this.update();
      }

      inputs() {
        return Array.from(this.querySelectorAll('[data-ess-row] [data-ncs-qty]')).filter((input) => !input.disabled);
      }

      state() {
        let count = 0;
        let total = 0;
        const lines = [];
        for (const input of this.inputs()) {
          const row = input.closest('[data-ess-row]');
          const qty = Math.max(0, Math.min(99, Math.floor(Number(input.value)) || 0));
          row.classList.toggle('is-zero', qty === 0);
          if (qty > 0) {
            lines.push({ id: Number(row.dataset.variantId), quantity: qty });
            count += qty;
            total += qty * Number(row.dataset.price);
          }
        }
        return { count, total, lines };
      }

      onQty(event) {
        if (event.target instanceof HTMLInputElement && event.target.matches('[data-ncs-qty]')) this.update();
      }

      update() {
        const { count, total } = this.state();
        const totalEl = this.querySelector('[data-ess-total]');
        const htEl = this.querySelector('[data-ess-ht]');
        const ship = this.querySelector('[data-ess-ship]');
        const shipText = this.querySelector('[data-ess-ship-text]');
        const btn = this.querySelector('[data-ess-add]');
        const label = this.querySelector('[data-ess-label]');
        const reset = this.querySelector('[data-ess-reset]');
        if (totalEl) totalEl.textContent = money(total);
        if (htEl) htEl.textContent = `soit ${money(total / this.vatDiv)} HT`;
        if (ship && shipText && this.threshold > 0) {
          const remaining = this.threshold - total;
          const reached = total > 0 && remaining <= 0;
          ship.classList.toggle('is-reached', reached);
          if (total <= 0) shipText.textContent = `Livraison offerte dès ${money(this.threshold, true)} (France métropolitaine)`;
          else if (reached) shipText.textContent = 'Livraison offerte avec cette sélection (France métropolitaine)';
          else shipText.textContent = `Encore ${money(remaining)} pour la livraison offerte (France métropolitaine)`;
        }
        if (btn && !btn.classList.contains('is-busy') && !btn.classList.contains('is-done')) {
          if (label) label.textContent = count ? `Ajouter au panier (${count}) · ${money(total)}` : 'Ajouter au panier';
          btn.disabled = count === 0;
        }
        if (reset) {
          const restore = count === 0 && this.defaultQty > 0;
          reset.textContent = restore ? `Tout remettre à ${this.defaultQty}` : 'Tout remettre à zéro';
          reset.hidden = count === 0 && !restore;
        }
      }

      message(text) {
        const box = this.querySelector('[data-ess-msg]');
        if (box) box.textContent = text || '';
      }

      async add(btn) {
        if (btn.disabled || btn.classList.contains('is-busy')) return;
        const { lines } = this.state();
        if (!lines.length) return;
        const label = this.querySelector('[data-ess-label]');
        btn.classList.add('is-busy');
        btn.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'Ajout...';
        this.message('');
        const result = await addLines(lines, btn, this);
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        if (result && result.ok) {
          btn.classList.add('is-done');
          setTimeout(() => {
            btn.classList.remove('is-done');
            this.update();
          }, 1200);
        } else {
          this.message((result && result.message) || 'Ajout impossible, réessayez.');
        }
        this.update();
      }

      reset() {
        const restore = this.state().count === 0;
        for (const input of this.inputs()) {
          input.value = String(restore ? Number(input.dataset.default || this.defaultQty) : 0);
        }
        if (window.NCS && window.NCS.initSteppers) window.NCS.initSteppers(this);
        this.update();
        if (window.NCS && window.NCS.announce) {
          window.NCS.announce(restore ? 'Quantités proposées rétablies' : 'Quantités remises à zéro');
        }
      }
    }

    customElements.define('ncs-essentials', NcsEssentials);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncs-fo-faq"] && !Shopify.designMode) return;
  try {
    
  /* Éditeur de thème : la question choisie dans le panneau s'ouvre. */
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target instanceof Element ? event.target.closest('.ncs-fo-faq__item') : null;
    if (item) item.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncs-fo-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ncs-fo-sticky')) return;

    /* "Demander une date" : l'ancre fait défiler vers #reserver (CSS, marge sous l'en-tête),
       puis le focus va au premier choix du formulaire, sans redéfiler. */
    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[data-ncs-fo-book]') : null;
      if (!link) return;
      if (!document.getElementById('reserver')) return;
      const target = document.querySelector('[data-ncs-fo-booking] [data-ncs-fo-focus]');
      if (!target) return;
      window.requestAnimationFrame(() => {
        try {
          target.focus({ preventScroll: true });
        } catch (error) {
          target.focus();
        }
      });
    });

    /* Barre collante mobile : visible quand le bouton du hero est hors de l'écran,
       sauf si le formulaire ou le pied de page sont visibles. Aucun écouteur scroll. */
    class NcsFoSticky extends HTMLElement {
      connectedCallback() {
        this.onSectionLoad = () => this.setup();
        document.addEventListener('shopify:section:load', this.onSectionLoad);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
        if (this.observer) this.observer.disconnect();
        this.observer = null;
      }

      setup() {
        if (!this.isConnected || !('IntersectionObserver' in window)) return;
        if (this.observer) this.observer.disconnect();
        const cta = document.querySelector('[data-ncs-fo-hero-cta]');
        if (!cta) return;
        const watched = new Map([[cta, 'cta']]);
        const booking = document.querySelector('[data-ncs-fo-booking]') || document.getElementById('reserver');
        if (booking) watched.set(booking, 'booking');
        const footer = document.querySelector('footer');
        if (footer) watched.set(footer, 'footer');
        this.state = { cta: true, booking: false, footer: false };
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.state[watched.get(entry.target)] = entry.isIntersecting;
          });
          this.update();
        });
        watched.forEach((name, element) => this.observer.observe(element));
      }

      update() {
        const show = !this.state.cta && !this.state.booking && !this.state.footer;
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
      }
    }

    customElements.define('ncs-fo-sticky', NcsFoSticky);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncs-pose"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ncs-pose-builder')) return;

    const formatMoney = (cents) => {
      if (window.NCS && typeof window.NCS.money === 'function') return window.NCS.money(cents);
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    };

    const ncsReady = () =>
      new Promise((resolve) => {
        if (window.NCS && window.NCS.addLines) {
          resolve(window.NCS);
          return;
        }
        document.addEventListener('ncs:ready', () => resolve(window.NCS), { once: true });
        setTimeout(() => resolve(window.NCS || null), 4000);
      });

    /* Montant du panier renvoye par l'evenement standard (montant decimal, ex. "41.70") */
    const cartTotalCents = (cart) => {
      const amount = cart && cart.cost && cart.cost.totalAmount ? Number.parseFloat(cart.cost.totalAmount.amount) : NaN;
      return Number.isFinite(amount) ? Math.round(amount * 100) : null;
    };

    class NcsPoseBuilder extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.threshold || 0);
        this.cartTotal = Number(this.dataset.cartTotal || 0);
        this.cartCount = Number(this.dataset.cartCount || 0);
        this.vat = Number(this.dataset.vat || 100);
        this.busy = false;

        this.onChange = (event) => this.handleChange(event);
        this.onClick = (event) => this.handleClick(event);
        this.onCart = (event) => {
          if (!event.promise) return;
          event.promise
            .then((result) => {
              if (!result || !result.cart) return;
              const total = cartTotalCents(result.cart);
              if (total === null) return;
              this.cartTotal = total;
              this.cartCount = Number(result.cart.totalQuantity || 0);
              this.paint();
            })
            .catch(() => {});
        };
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:cart:lines-update', this.onCart);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            const visible = entries.some((entry) => entry.isIntersecting);
            document.body.classList.toggle('ncs-pose-hides-sticky', visible);
          });
          this.observer.observe(this);
        }
        this.paint();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:cart:lines-update', this.onCart);
        if (this.observer) this.observer.disconnect();
        document.body.classList.remove('ncs-pose-hides-sticky');
      }

      checks() {
        return Array.from(this.querySelectorAll('[data-pose-check]'));
      }

      selected() {
        return this.checks().filter((input) => input.checked);
      }

      handleChange(event) {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        if (target.matches('[data-pose-check]')) {
          const item = target.closest('[data-pose-item]');
          if (item) item.classList.toggle('is-on', /** @type {HTMLInputElement} */ (target).checked);
          this.paint();
          return;
        }
        if (target instanceof HTMLSelectElement && target.matches('[data-pose-select]')) {
          const option = target.selectedOptions[0];
          const slot = target.closest('.ncs-pose__items');
          const input = slot ? slot.querySelector('[data-pose-check]') : null;
          if (!option || !input) return;
          const item = input.closest('[data-pose-item]');
          input.dataset.variantId = option.value;
          input.dataset.price = option.dataset.price || '0';
          input.dataset.title = option.dataset.title || '';
          input.checked = true;
          if (item) {
            item.classList.add('is-on');
            const name = item.querySelector('[data-pose-name]');
            const price = item.querySelector('[data-pose-price]');
            const img = item.querySelector('[data-pose-img]');
            if (name) name.textContent = option.dataset.title || '';
            if (price) price.textContent = option.dataset.priceText || formatMoney(Number(option.dataset.price || 0));
            if (img && option.dataset.img) img.src = option.dataset.img;
          }
          this.paint();
        }
      }

      handleClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const tip = target.closest('[data-pose-tip-add]');
        if (tip) {
          const input = this.checks().find((el) => el.dataset.variantId === tip.dataset.poseTipAdd);
          if (input) {
            input.checked = true;
            const item = input.closest('[data-pose-item]');
            if (item) item.classList.add('is-on');
            this.paint();
            input.focus({ preventScroll: true });
          }
          return;
        }
        const add = target.closest('[data-pose-add]');
        if (add) this.add(/** @type {HTMLButtonElement} */ (add));
      }

      paint() {
        const selected = this.selected();
        const total = selected.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
        const count = selected.length;

        const sum = this.querySelector('[data-pose-sum]');
        if (sum) sum.textContent = formatMoney(total);
        const ht = this.querySelector('[data-pose-ht]');
        if (ht) ht.textContent = `soit ${formatMoney(Math.round((total * 100) / this.vat))} HT`;

        const label = this.querySelector('[data-pose-label]');
        if (label && !this.busy) label.textContent = `Ajouter la pose (${count}) · ${formatMoney(total)}`;
        const button = this.querySelector('[data-pose-add]');
        if (button) button.disabled = count === 0;

        const ship = this.querySelector('[data-pose-ship]');
        const tipEl = this.querySelector('[data-pose-tip]');
        let tipInput = null;
        if (ship && this.threshold > 0) {
          const withCart = this.cartCount > 0;
          const left = this.threshold - this.cartTotal - total;
          ship.hidden = false;
          ship.classList.toggle('is-reached', left <= 0);
          if (left > 0) {
            ship.textContent = withCart
              ? `Avec votre panier : encore ${formatMoney(left)} pour la livraison offerte.`
              : `Encore ${formatMoney(left)} pour la livraison offerte.`;
            /* Le produit de preparation non coche le moins cher qui fait passer le seuil (calcul reel) */
            tipInput =
              this.checks()
                .filter((el) => el.dataset.poseRole === 'prep' && !el.checked && Number(el.dataset.price || 0) >= left)
                .sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price))[0] || null;
          } else {
            ship.textContent = withCart
              ? 'Avec votre panier, livraison offerte en France métropolitaine.'
              : 'Livraison offerte en France métropolitaine avec cette sélection.';
          }
        }
        if (tipEl) {
          if (tipInput) {
            tipEl.hidden = false;
            tipEl.textContent = '';
            const text = document.createElement('span');
            text.textContent = `Ajoutez ${tipInput.dataset.title} (${formatMoney(Number(tipInput.dataset.price || 0))}) : livraison offerte.`;
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'ncs-pose__tipbtn';
            btn.dataset.poseTipAdd = tipInput.dataset.variantId || '';
            btn.textContent = 'Ajouter à la sélection';
            tipEl.append(text, btn);
          } else {
            tipEl.hidden = true;
            tipEl.textContent = '';
          }
        }
      }

      async add(button) {
        if (this.busy) return;
        const lines = this.selected().map((input) => ({ id: Number(input.dataset.variantId), quantity: 1 }));
        if (!lines.length) return;
        const msg = this.querySelector('[data-pose-msg]');
        const label = this.querySelector('[data-pose-label]');
        this.busy = true;
        button.classList.add('is-busy');
        button.setAttribute('aria-disabled', 'true');
        if (label) label.textContent = 'Ajout en cours';
        if (msg) msg.textContent = '';

        let result;
        const NCS = await ncsReady();
        if (NCS && NCS.addLines) {
          result = await NCS.addLines(lines, button);
        } else {
          /* Secours sans assets/ncs.js : ajout direct puis page panier */
          try {
            const res = await fetch(this.dataset.cartAddUrl || '/cart/add', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: lines }),
            });
            const json = await res.json();
            result = json.status ? { ok: false, message: json.description || json.message } : { ok: true };
            if (result.ok) window.location.assign(this.dataset.cartUrl || '/cart');
          } catch (error) {
            result = { ok: false, message: 'Connexion interrompue, réessayez.' };
          }
        }

        this.busy = false;
        button.classList.remove('is-busy');
        button.removeAttribute('aria-disabled');
        this.paint();
        if (result && result.ok) {
          button.classList.add('is-done');
          setTimeout(() => button.classList.remove('is-done'), 1200);
        } else if (msg) {
          msg.textContent = (result && result.message) || 'Ajout impossible pour le moment, réessayez.';
        }
      }
    }

    customElements.define('ncs-pose-builder', NcsPoseBuilder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncs-shades"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ncs-shades')) return;

    const locale = document.documentElement.lang || 'fr';
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const money = (cents) => {
      const value = Math.round(cents) / 100;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);
      } catch (e) {
        return `${value.toFixed(2).replace('.', ',')} €`;
      }
    };
    const plural = (count, one, many) => `${count} ${count > 1 ? many : one}`;
    const reducedMotion = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ncsReady = () =>
      new Promise((resolve) => {
        if (window.NCS && window.NCS.addLines) {
          resolve(window.NCS);
          return;
        }
        document.addEventListener('ncs:ready', () => resolve(window.NCS), { once: true });
        setTimeout(() => resolve(window.NCS || null), 4000);
      });
    const announce = (text) => {
      if (window.NCS && window.NCS.announce) window.NCS.announce(text);
    };

    /* Ajout groupe : window.NCS.addLines (tiroir Horizon), sinon ajout direct puis page panier */
    const addLines = async (lines, source, root) => {
      const NCS = await ncsReady();
      if (NCS && NCS.addLines) return NCS.addLines(lines, source);
      try {
        const res = await fetch(root.dataset.cartAddUrl || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: lines }),
        });
        const json = await res.json();
        if (json.status) return { ok: false, message: json.description || json.message };
        window.location.assign(root.dataset.cartUrl || '/cart');
        return { ok: true };
      } catch (e) {
        return { ok: false, message: 'Connexion interrompue, réessayez.' };
      }
    };

    class NcsShades extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.vatDiv = 1 + Number(this.dataset.vat || 20) / 100;
        this.threshold = Number(this.dataset.threshold || 0);
        this.selection = new Map();
        this.swatches = Array.from(this.querySelectorAll('[data-shd-sw]'));
        this.current = this.querySelector('[data-shd-sw].is-current') || this.swatches[0] || null;

        this.addEventListener('click', (event) => {
          const target = event.target instanceof Element ? event.target : null;
          if (!target) return;
          const swatch = target.closest('[data-shd-sw]');
          if (swatch) {
            this.pick(swatch, true);
            return;
          }
          const chip = target.closest('[data-shd-fam]');
          if (chip) {
            this.filter(chip);
            return;
          }
          const add = target.closest('[data-shd-add]');
          if (add) {
            this.add(add);
            return;
          }
          if (target.closest('[data-shd-clear]')) this.clear();
        });

        const card = this.querySelector('[data-shd-card]');
        const onQty = (event) => {
          const input = event.target instanceof HTMLInputElement && event.target.matches('[data-shd-qty]') ? event.target : null;
          if (!input || !this.current) return;
          if (event.type === 'input' && input.value === '') return;
          this.setQty(this.current, input.value);
        };
        if (card) {
          card.addEventListener('input', onQty);
          card.addEventListener('change', onQty);
        }
        this.renderPreview(false);
        this.renderSummary();
      }

      qty(swatch) {
        return this.selection.get(swatch.dataset.handle) || 0;
      }

      setQty(swatch, value) {
        const qty = Math.max(0, Math.min(99, Math.floor(Number(value)) || 0));
        if (qty > 0 && swatch.dataset.avail === 'true') this.selection.set(swatch.dataset.handle, qty);
        else this.selection.delete(swatch.dataset.handle);
        this.syncSwatch(swatch);
        this.renderSummary();
      }

      syncSwatch(swatch) {
        const qty = this.qty(swatch);
        swatch.setAttribute('aria-pressed', qty > 0 ? 'true' : 'false');
        swatch.classList.toggle('is-current', swatch === this.current);
        const dot = swatch.querySelector('.ncs-swatch');
        let badge = dot ? dot.querySelector('.ncs-swatch__count') : null;
        if (qty > 0 && dot) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'ncs-swatch__count';
            badge.setAttribute('aria-hidden', 'true');
            dot.append(badge);
          }
          badge.textContent = String(qty);
        } else if (badge) {
          badge.remove();
        }
        const sr = swatch.querySelector('[data-shd-srq]');
        if (sr) {
          if (swatch.dataset.avail !== 'true') sr.textContent = ', épuisé';
          else sr.textContent = qty ? `, ${qty} dans la sélection` : '';
        }
      }

      pick(swatch, add) {
        const previous = this.current;
        this.current = swatch;
        if (previous && previous !== swatch) this.syncSwatch(previous);
        if (add && swatch.dataset.avail === 'true') {
          this.setQty(swatch, this.qty(swatch) + 1);
          announce(`${swatch.dataset.title} : ${this.qty(swatch)} dans la sélection`);
        } else {
          this.syncSwatch(swatch);
        }
        this.renderPreview(previous !== swatch);
      }

      renderPreview(animate) {
        const swatch = this.current;
        const card = this.querySelector('[data-shd-card]');
        if (!swatch || !card) return;
        const data = swatch.dataset;
        const pose = data.pose === 'true';
        const photo = card.querySelector('[data-shd-photo]');
        const poseBadge = card.querySelector('[data-shd-pose]');
        if (photo) photo.classList.toggle('is-pose', pose);
        if (poseBadge) poseBadge.hidden = !pose;
        const img = card.querySelector('.ncs-shd__photo img');
        if (img && data.img) {
          img.srcset = data.srcset || '';
          img.src = data.img;
          if (data.w) img.width = Number(data.w);
          if (data.h) img.height = Number(data.h);
          img.alt = data.alt || '';
          /* geste repete : seule la photo s'anime, brievement */
          if (animate && img.animate && !reducedMotion()) {
            img.animate([{ opacity: 0.4 }, { opacity: 1 }], { duration: 120, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
          }
        }
        const price = Number(data.price || 0);
        const name = card.querySelector('[data-shd-name]');
        const shortName = card.querySelector('[data-shd-short]');
        const sku = card.querySelector('[data-shd-sku]');
        const priceEl = card.querySelector('[data-shd-price]');
        const htEl = card.querySelector('[data-shd-ht]');
        const link = card.querySelector('[data-shd-link]');
        const stepper = card.querySelector('[data-shd-stepper]');
        const input = card.querySelector('[data-shd-qty]');
        const out = card.querySelector('[data-shd-out]');
        if (name) name.textContent = data.title || '';
        if (shortName) shortName.textContent = data.short || data.title || '';
        if (sku) sku.textContent = data.sku ? `Réf. ${data.sku}` : '';
        if (priceEl) priceEl.textContent = money(price);
        if (htEl) htEl.textContent = `soit ${money(price / this.vatDiv)} HT`;
        if (link && data.url) link.href = data.url;
        const available = data.avail === 'true';
        if (stepper) stepper.hidden = !available;
        if (out) out.hidden = available;
        if (input) {
          input.value = String(this.qty(swatch));
          input.setAttribute('aria-label', `Quantité de ${data.title || ''} dans la sélection`);
        }
        if (stepper && window.NCS && window.NCS.initSteppers) window.NCS.initSteppers(card);
      }

      filter(chip) {
        const family = chip.dataset.shdFam;
        for (const other of this.querySelectorAll('[data-shd-fam]')) {
          other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
        }
        for (const swatch of this.swatches) {
          swatch.hidden = family !== 'all' && swatch.dataset.fam !== family;
        }
        /* la teinte apercue suit le filtre : si elle sort de la grille, on prend la premiere visible, sans l'ajouter */
        if (this.current && this.current.hidden) {
          const first = this.swatches.find((swatch) => !swatch.hidden);
          if (first) this.pick(first, false);
        }
      }

      lines() {
        const lines = [];
        let units = 0;
        let total = 0;
        for (const swatch of this.swatches) {
          const qty = this.qty(swatch);
          if (qty < 1 || swatch.dataset.avail !== 'true') continue;
          lines.push({ id: Number(swatch.dataset.id), quantity: qty });
          units += qty;
          total += qty * Number(swatch.dataset.price || 0);
        }
        return { lines, units, total };
      }

      renderSummary() {
        const { lines, units, total } = this.lines();
        const line = this.querySelector('[data-shd-sumline]');
        const ship = this.querySelector('[data-shd-sumship]');
        const btn = this.querySelector('[data-shd-add]');
        const label = this.querySelector('[data-shd-label]');
        const clear = this.querySelector('[data-shd-clear]');
        if (line) {
          line.textContent = lines.length
            ? `${plural(lines.length, 'teinte', 'teintes')}${units !== lines.length ? `, ${plural(units, 'article', 'articles')}` : ''}, ${money(total)}`
            : 'Touchez une teinte pour l’ajouter à votre sélection.';
        }
        if (ship) {
          const show = lines.length > 0 && this.threshold > 0;
          ship.hidden = !show;
          if (show) {
            const remaining = this.threshold - total;
            ship.classList.toggle('is-reached', remaining <= 0);
            ship.textContent = remaining <= 0
              ? 'Livraison offerte avec cette sélection (France métropolitaine)'
              : `Encore ${money(remaining)} pour la livraison offerte (France métropolitaine)`;
          }
        }
        if (btn && !btn.classList.contains('is-busy') && !btn.classList.contains('is-done')) {
          if (label) label.textContent = units ? `Ajouter au panier (${units}) · ${money(total)}` : 'Ajouter au panier';
          btn.disabled = units === 0;
        }
        if (clear) clear.hidden = lines.length === 0;
      }

      message(text) {
        const box = this.querySelector('[data-shd-msg]');
        if (box) box.textContent = text || '';
      }

      async add(btn) {
        if (btn.disabled || btn.classList.contains('is-busy')) return;
        const { lines } = this.lines();
        if (!lines.length) return;
        const label = this.querySelector('[data-shd-label]');
        btn.classList.add('is-busy');
        btn.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'Ajout...';
        this.message('');
        const result = await addLines(lines, btn, this);
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        if (result && result.ok) {
          btn.classList.add('is-done');
          this.selection.clear();
          for (const swatch of this.swatches) this.syncSwatch(swatch);
          this.renderPreview(false);
          setTimeout(() => {
            btn.classList.remove('is-done');
            this.renderSummary();
          }, 1200);
        } else {
          this.message((result && result.message) || 'Ajout impossible, réessayez.');
        }
        this.renderSummary();
      }

      clear() {
        this.selection.clear();
        for (const swatch of this.swatches) this.syncSwatch(swatch);
        this.renderPreview(false);
        this.renderSummary();
        announce('Sélection vidée');
      }
    }

    customElements.define('ncs-shades', NcsShades);
  })();

  } catch(e) { console.error(e); }
})();
})();
